module.exports = __webpack_public_path__ + "static/media/wne_logo.122418cb.svg";